// Copyright (c) 2016 Deere & Company

import actions from '../../actions-list';

export const updateLaborStatsSearchCriteria = partNumber => ({
    partNumber,
    type: actions.UPDATE_LABOR_STATS_SEARCH_CRITERIA
});



// WEBPACK FOOTER //
// ./src/reports/labor-stats/action-creators/criteria.js